import { useContext } from 'react';
import { CardContext } from '../../utils/cardContext';
import { Underground } from '../../components/Building/parts/Underground';
import { UIText2 } from '@cian/ui-kit';

export const Address = () => {
  const { undergroundInfo, fullAddress } = useContext(CardContext);

  return (
    <div>
      {undergroundInfo && <Underground {...undergroundInfo} />}
      <UIText2 color="gray60_100">{fullAddress}</UIText2>
    </div>
  );
};
